import * as React from "react";

const ExpandMore: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M11.06 5.53L8 8.583 4.94 5.53 4 6.47l4 4 4-4-.94-.94z"
                fill="#fff"
            />
        </svg>
    )
};
export default React.memo(ExpandMore);
